import React from 'react';
import { flattenRichText } from 'utils/richTextUtils';
import WistiaVideo from 'components/Core/WistiaVideo';

const RichTextVideo = ({ fields, ...otherProps }) => {
  const { ctaBody, ctaTitle, sharableLink, size, playVideoInline, popoverCta, videoPreviewImage } =
    flattenRichText(fields) || {};

  return (
    <WistiaVideo
      ctaBody={ctaBody}
      ctaTitle={ctaTitle}
      dataPosition="Rich Text"
      inline={playVideoInline}
      popoverCta={popoverCta}
      size={size || 'Medium'}
      thumbnail={videoPreviewImage}
      url={sharableLink}
      wrapperStyles={{ margin: '40px auto' }}
      {...otherProps}
    />
  );
};

export default RichTextVideo;
